import React from 'react';

const About = () => {
    return (
        <div className="container mt-5 py-5 d-flex align-items-center justify-content-center">
            <img className="me-5" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7IQRG4Us9dLCY55rjXN52Z29eXW7SJ1-jkQ&usqp=CAU" alt="" />

            <div>
                <h1>About Us:</h1>
                <p>
                    More and more children and young people need to develop higher level thinking skills in order to find solutions to social, emotional and economic problems, both personally and in the context of the wider world. They are encouraged to be creative, innovative, enterprising and adaptable, with the motivation, confidence and skills to use creative and critical thinking purposefully.


                    The main beneficiaries of the project include primary and secondary school teachers, who, through engaging with the project will become equipped with the skills necessary to facilitate pedagogical strategies for creativity and critical thinking. Children and young people involved as participants in the Creative School project will develop the skills required to respond to the challenges offered by the Creative School curriculum.</p>
            </div>

        </div>
    );
};

export default About;